import { Box, Typography } from '@mui/material';

export interface PersonalizeWysiwygOptionProps {
  onClick: () => void;
}

// border: 1px solid #F1F1F1;
//     padding: 5px;
//     min-width: 25px;
//     height: 20px;
//     border-radius: 2px;
//     margin: 0 4px;
//     display: flex
// ;
//     justify-content: center;
//     align-items: center;
//     cursor: pointer;
//     background: white;
//     text-transform: capitalize;

export const PersonalizeWysiwygOption = (props: PersonalizeWysiwygOptionProps) => {
  return (
    <Box sx={{ border: '1px solid #F1F1F1', padding: '5px', height: '20px', borderRadius: '2px', margin: '0 4px', display: 'flex', justifyContent: 'center' , alignItems: 'center', cursor: 'pointer' ,background: 'white', textTransform: 'capitalize' }}>
      <Typography sx={{}} onClick={props.onClick}>
        Personalize
      </Typography>
    </Box>
  );
};
